import { coreSonarTaskConfigsByOrganizationIdAndTaskTypeGetAsyncSlice } from './get';
import { coreSonarTaskConfigsByOrganizationIdAndTaskTypePatchAsyncSlice } from './patch';

export const
	{
		requestGetCoreSonarTaskConfigsByOrganizationIdAndTaskType,
		resetGetCoreSonarTaskConfigsByOrganizationIdAndTaskType
	} =	coreSonarTaskConfigsByOrganizationIdAndTaskTypeGetAsyncSlice.asyncActionCreators;

export const
	{
		requestPatchCoreSonarTaskConfigsByOrganizationIdAndTaskType,
		resetPatchCoreSonarTaskConfigsByOrganizationIdAndTaskType
	} = coreSonarTaskConfigsByOrganizationIdAndTaskTypePatchAsyncSlice.asyncActionCreators;
